export default __webpack_public_path__ + "static/media/gilab.a9ff2a14.svg";